import { ExpandMore, HomeWorkOutlined } from '@material-ui/icons';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from '@material-ui/core';
import { ItemDisplay } from '../../../components/itemDisplay';
import { observer } from 'mobx-react';
import { getCompletePropertyAddress } from '@roc/ui/utils';
import { ViewControls } from '../../../components/viewControls';
import { RoundedBackgroundIcon } from '../../../components/roundedBackgroundIcon';
import { PropertyFormStore } from '../../../stores/properties/propertyFormStore';
import { TitleDivider } from '../../../components/titleDivider';
import { ReactNode } from 'react';
import { PropertyDetailsTable } from './propertyDetailsTable';


interface RentalPortfolioPropertyInformationProps {
  store: PropertyFormStore;
  onDeleteClick?: (propertyKey: string) => void;
  removeButtonDisabled?: boolean;
  showRemoveButton?: boolean;
  showActions?: boolean;
  expanded: boolean;
  bottom?: ReactNode;
  onExpand: (expanded: boolean) => void;
  onEdit: () => void;
}

export const RentalPortfolioPropertyInformation = observer(
  ({
    store,
    onDeleteClick = () => null,
    showActions = true,
    showRemoveButton = true,
    removeButtonDisabled = false,
    expanded,
    bottom,
    onEdit,
    onExpand
  }: RentalPortfolioPropertyInformationProps) => {
    const property = store.getFormValues();
    const propertyKey = store.key;

    let completeAddress = getCompletePropertyAddress(property);
    if (
      completeAddress === '' ||
      completeAddress.replace(/,/g, '').trim() === ''
    ) {
      completeAddress = '-';
    }

    return (

      <>

        <Accordion
          expanded={expanded}
          onChange={(e, expanded) => onExpand(expanded)}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={<ExpandMore fontSize="large" />}
            aria-controls={`property-information-accordion-${propertyKey}`}
          >
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid
                item
                container
                spacing={2}
                xs={8}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item alignItems="center" style={{ height: '100%' }}>
                  <RoundedBackgroundIcon
                    Icon={HomeWorkOutlined}
                    iconColor="#6D6D6D"
                  />
                </Grid>
                <Grid item>
                  <ItemDisplay
                    label="Property Type"
                    value={property.propertyType}
                    alignItems="flex-start"
                  />
                </Grid>
                <Grid item>
                  <ItemDisplay
                    label="Property Address"
                    value={completeAddress}
                    alignItems="flex-start"
                  />
                </Grid>
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <Grid
              container
              alignItems="center"
              spacing={2}
              style={{ marginLeft: '58px' }}
            >
              {showActions && (
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <ViewControls
                      onDeleteClick={() => onDeleteClick(propertyKey)}
                      onEditClick={onEdit}
                      showRemoveButton={showRemoveButton}
                      removeButtonDisabled={removeButtonDisabled}
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12}>
                <TitleDivider title="Property Details" />
              </Grid>
              <Grid item xs={12}>
                <PropertyDetailsTable store={store} />
              </Grid>
              {bottom}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </>

    );
  }
);
